import angular from 'angular';
import CSMCommonWeb from 'csm-common-web';
import booksMenu from '../../menu/Menu';
import vendorListDialog from './dialogs/VendorListDialog';
import './vendorsAdmin.css';

export default angular
  .module('vendorsAdmin', [CSMCommonWeb, booksMenu, vendorListDialog])
  .controller('VendorsController', VendorsAdminController).name;

/*******************************************************************************
 * VendorsAdminController */
/**
 * Controller for the Vendors Admin app.
 *******************************************************************************/
/* @ngInject */ function VendorsAdminController(
  $appFlags,
  $scope,
  Alert,
  AddChangeVendorDialog,
  BooksSvc,
  BusyScreen,
  EntityListItem,
  MergeEntityDialog,
  SERVER,
  uiGridConstants,
  VendorListDialog
) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Instance reference. */ var mThis = this;
  /** Merge Dialog shown. */ var mMergeEntityDialogActive = false;
  /** Vendor List Dialog shown. */ var mVendorListActive = false;
  /** Add/Change dialog shown. */ var mVendorDialogActive = false;

  /*-----------*/
  /* App Flags */
  /*-----------*/
  /** Restrict vendor modification. */ $scope.restrictVendors =
    SERVER.appFlags.restrictVendors;
  /** District Wide Flag */ $scope.isDistBook =
    SERVER.appFlags.createDistrictWideVendors;

  /*-----------------------------------------------------*/
  /* Template to add double click functionality to each  */
  /* grid row. Begins editing the double clicked vendor. */
  /*-----------------------------------------------------*/
  var dblClickTemplate =
    '<div ng-dblclick="grid.appScope.changeVendor(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

  /*------------------------------------------------------------*/
  /* Template for the actions column with icons to edit vendor, */
  /* make ASB card holder, merge vendor and delete vendor.      */
  /* If the restrictVendors flag is set, only the view icon     */
  /* will be shown for users that it applies to. They can view  */
  /* the vendor details, but cannot edit or delete them.        */
  /*------------------------------------------------------------*/
  var actionsCellTemplate =
    '<div class="ui-grid-cell-contents ng-binding ng-scope"> ' +
    "<span><span class=\"glyphicon {{grid.appScope.restrictVendors ? 'glyphicon-eye-open' : 'glyphicon-edit'}} csm-grid-space-target pointer\" title=\"{{grid.appScope.restrictVendors ? 'View' : 'Change'}}\" ng-click=\"(col.colDef.appScope || grid.appScope).changeVendor(row.entity)\"></span> &nbsp;</span>" +
    '<span ng-hide="grid.appScope.restrictVendors"><span class="glyphicon glyphicon-resize-small csm-grid-space-target pointer" title="Merge"  ng-click="(col.colDef.appScope || grid.appScope).handleMerge(row.entity)"></span> &nbsp;</span>' +
    '<span ng-hide="grid.appScope.restrictVendors"><span class="glyphicon glyphicon-trash        csm-grid-space-target pointer" title="Remove" ng-click="(col.colDef.appScope || grid.appScope).removeVendor(row.entity)"></span> &nbsp;</span>' +
    '</div>';

  /*****************************************************************************
   * addChangeVendor */
  /**
   * Opens the AddChangeVendorDialog for vendor creation or update.
   *****************************************************************************/
  function addChangeVendor(vendorID) {
    mVendorDialogActive = true;
    AddChangeVendorDialog.show(vendorID, null)
      .then(function () {
        BusyScreen.setBusy(true);
        return loadVendors().then(function () {
          BusyScreen.setBusy(false);
        });
      })
      .finally(function () {
        mVendorDialogActive = false;
      });
  }

  /*****************************************************************************
   * addVendor */
  /**
   * Opens the AddChangeVendorDialog for vendor creation.
   *****************************************************************************/
  $scope.addVendor = function () {
    /*------------------------------*/
    /* Dialog already active, exit. */
    /*------------------------------*/
    if (mVendorDialogActive) return;

    addChangeVendor();
  };

  /*****************************************************************************
   * changeVendor */
  /**
   * Opens the AddChangeVendorDialog for vendor edits.
   *****************************************************************************/
  $scope.changeVendor = function (vendor) {
    /*------------------------------*/
    /* Dialog already active, exit. */
    /*------------------------------*/
    if (mVendorDialogActive) return;

    /*-----------------------*/
    /* Check for a selection */
    /*-----------------------*/
    if (!vendor) {
      Alert.info('Please make a selection from the list.', 'No Selection');
      return;
    }

    addChangeVendor(vendor.id);
  };

  /*****************************************************************************
   * getInactiveCellClass */
  /**
   * Returns the CSS class name to be applied to the grid cell on inactive
   * items.
   *
   * @param  grid   ui-grid reference
   * @param  row    ui-grid row
   * @param  col    ui-grid column
   *
   * @return  String   CSS class name inactive-cell-content or empty string.
   *****************************************************************************/
  function getInactiveCellClass(grid, row, col) {
    return !row.entity.active ? 'inactive-cell-content' : '';
  }

  /***************************************************************************
   * handleMerge */
  /**
   * Displays the dialog to handle merging entities.
   *
   * @param   entity  Entity to merge to.
   ***************************************************************************/
  $scope.handleMerge = function (entity) {
    /*------------------------------*/
    /* Dialog already active, exit. */
    /*------------------------------*/
    if (mMergeEntityDialogActive) return;

    /*-----------------------*/
    /* Check for a selection */
    /*-----------------------*/
    if (!entity) {
      Alert.info('Please make a selection from the list.', 'No Selection');
      return;
    }

    /*---------------------------------------*/
    /* Display the dialog to merge entities. */
    /*---------------------------------------*/
    mMergeEntityDialogActive = true;
    MergeEntityDialog.show(entity.id, entity.name, mThis.dpVendors)
      .then(function () {
        BusyScreen.setBusy(true);
        return loadVendors().then(function () {
          $scope.dgVendors.api.core.refresh();
          BusyScreen.setBusy(false);
          Alert.success('Merge Successful.');
        });
      })
      .finally(function () {
        mMergeEntityDialogActive = false;
      });
  };

  /*****************************************************************************
   * handlePrint */
  /**
   * Displays the dialog to handle the printig.
   *****************************************************************************/
  $scope.handlePrint = function () {
    /*------------------------------*/
    /* Dialog already active, exit. */
    /*------------------------------*/
    if (mVendorListActive) return;

    mVendorListActive = true;
    VendorListDialog.show(mThis.dpVendors)
      .then(function () {})
      .finally(function () {
        mVendorListActive = false;
      });
  };

  /*****************************************************************************
   * init */
  /**
   * Initializes the ui-grid data and the list of vendors.
   *****************************************************************************/
  function init() {
    /*----------------------*/
    /* Vendors List options */
    /*----------------------*/
    $scope.dgVendors = {
      enableColumnMenus: false,
      enableFiltering: true,
      enableRowSelection: true,
      enableFullRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      enableSelectAll: false,
      saveFilter: true,
      saveSort: true,
      rowTemplate: dblClickTemplate,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      onRegisterApi: function (gridApi) {
        $scope.dgVendors.api = gridApi;
      },
      data: [],
      /**
       * The width add up to 99% to leave room for the vertical scrollbar that appears. This will
       * prevent the horizontal scrollbar from appearing unnecessarily.
       */
      columnDefs: [
        {
          cellClass: getInactiveCellClass,
          field: 'name',
          displayName: 'Vendor Name',
          width: '42%',
          minWidth: 200
        },
        {
          cellClass: getInactiveCellClass,
          field: 'notes',
          width: '22%',
          minWidth: 240
        },
        {
          cellClass: getInactiveCellClass,
          field: 'active',
          width: '7%',
          minWidth: 75,
          displayName: 'Active?',
          cellFilter: 'boolToString',
          filter: {
            term: true,
            type: uiGridConstants.filter.SELECT,
            selectOptions: [
              { value: null, label: 'ALL' },
              { value: true, label: 'Y' },
              { value: false, label: 'N' }
            ]
          }
        },
        {
          cellClass: getInactiveCellClass,
          field: 'f1099',
          width: '7%',
          minWidth: 75,
          displayName: '1099?',
          cellFilter: 'boolToString',
          filter: {
            term: null,
            type: uiGridConstants.filter.SELECT,
            selectOptions: [
              { value: null, label: 'ALL' },
              { value: true, label: 'Y' },
              { value: false, label: 'N' }
            ]
          }
        },
        {
          cellClass: getInactiveCellClass,
          field: 'taxID',
          displayName: 'Tax ID',
          width: '15%',
          minWidth: 135,
          filter: { condition: uiGridConstants.filter.STARTS_WITH }
        },
        {
          cellTemplate: actionsCellTemplate,
          enableFiltering: false,
          enableSorting: false,
          field: 'actions',
          width: '6%',
          minWidth: 80,
          displayName: 'Actions',
          pinnedRight: true
        }
      ]
    };

    loadVendors().then(function () {
      $scope.appReady = true;
      BusyScreen.setBusy(false);
    });
  }

  /*****************************************************************************
   * loadVendors */
  /**
   * Loads the list of vendors from the server.
   *****************************************************************************/
  function loadVendors() {
    return BooksSvc.getVendorList(false, true).then(function (resp) {
      $scope.dgVendors.data = mThis.dpVendors = resp.data
        .map(function (vendor) {
          return new EntityListItem(vendor);
        })
        .sortOn('name|NCASE');
    });
  }

  /*****************************************************************************
   * removeVendor */
  /**
   * Removes the selected vendor from the list.
   *
   * @param   entity  Entity to remove.
   *****************************************************************************/
  $scope.removeVendor = function (entity) {
    /*-----------------------*/
    /* Check for a selection */
    /*-----------------------*/
    if (!entity) {
      Alert.info('A selection is needed for the remove.', 'No Selection');
      return;
    }

    /*--------------------*/
    /* Confirm the remove */
    /*--------------------*/
    Alert.confirm(
      'Are you sure wish to remove this person?',
      'Remove Confirm'
    ).then(function () {
      BusyScreen.setBusy(true);

      /*----------------------------------------*/
      /* Remove the entity and reload the list. */
      /*----------------------------------------*/
      BooksSvc.removeEntity(SERVER.BooksDBConstants.ET_VENDOR, entity.id).then(
        function (resp) {
          return loadVendors().then(function () {
            BusyScreen.setBusy(false);
            Alert.success('Person sucessfully removed.');
          });
        },
        /*--------------------------------------------------*/
        /* Server responded with an error. Display to user. */
        /*--------------------------------------------------*/
        function (resp) {
          Alert.error(
            resp.parsedResponse.message() || 'Error deleting this person',
            'Failed to remove person.'
          );
          BusyScreen.setBusy(false);
        }
      );
    });
  };

  init();
}
